export default "__VITE_ASSET__DjF_0ogH__"